import styled, { css } from 'styled-components';
import { ThumbnailStyledProps } from './Thumbnail.typed';

export const Thumbnail = styled.div<ThumbnailStyledProps>`
  position: relative;
  width: 100%;
  background-color: #fafafa;
  ${({ image, fit }) =>
    !!image &&
    css`
      background-image: url(${image});
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: ${fit};
    `}
  border-radius: ${({ theme }) => theme.borderRadius.s};
  box-shadow: ${({ theme, elevated }) =>
    elevated ? theme.shadow.primary : 'none'};
  overflow: hidden;

  &:after {
    display: block;
    padding-bottom: ${({ aspectRatio }) =>
      (aspectRatio[1] / aspectRatio[0]) * 100}%;
    content: '';
  }

  ${({ image }) =>
    !image &&
    css`
      &:before {
        position: absolute;
        display: block;
        width: 100%;
        height: 100%;
        content: '';
        border: 1px dashed #d9d9d9;
      }
    `}

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: ${({ fit }) => fit};
  }
`;

export const Body = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Placeholder = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  padding: 0 ${({ theme }) => theme.spacing.M16};
  transform: translateY(-50%);
  font-size: ${({ theme }) => theme.typography.fontSizes['S12']};
  text-align: center;
  color: #999;
`;
